import { render } from "./BlogPost.vue?vue&type=template&id=dd710fb0&scoped=true"
import script from "../js/blog-post.js?vue&type=script&lang=js"
export * from "../js/blog-post.js?vue&type=script&lang=js"

import "./BlogPost.vue?vue&type=style&index=0&id=dd710fb0&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd710fb0"]])

export default __exports__